import { ReactNode } from "react";
import styled from "styled-components";
import { KeyboardArrowRight } from "~/guidelines/Icon";

const DisclosureWidget = styled.span`
  display: block;
  width: max-content;
  transition: transform 250ms ease-in-out;

  color: ${({ theme }) => theme.color.text.lightTertiary};
`;

const Detail = styled.details`
  &[open] ${DisclosureWidget} {
    transform: rotate(90deg);
  }
`;

const Summary = styled.summary`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(4)};
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }

  &[tabindex="-1"] {
    pointer-events: none;
    cursor: default;

    & ${DisclosureWidget} {
      display: none;
    }
  }
`;

export const Collapsible = ({
  title,
  isDisabled = undefined,
  isOpen = undefined,
  children,
}: {
  title: ReactNode;
  isDisabled?: boolean;
  isOpen?: boolean;
  children: ReactNode;
}) => {
  return (
    <Detail
      open={isDisabled ? isOpen : undefined}
      onClick={isDisabled ? (e) => e.preventDefault() : undefined}
    >
      <Summary tabIndex={isDisabled ? -1 : undefined}>
        {title}

        <DisclosureWidget>
          <KeyboardArrowRight />
        </DisclosureWidget>
      </Summary>

      <div>{children}</div>
    </Detail>
  );
};
